import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "./LogoMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchange = async () => {
      const params = new URLSearchParams(window.location.hash.slice(1));
      const sessionId = params.get("session_id");
      try {
        if (sessionId) {
          const r = await axios.post(
            `${API}/auth/session`,
            { session_id: sessionId },
            { withCredentials: true },
          );
          setUser(r.data.user);
        }
      } catch (e) {
        console.error("Google sign-in failed:", e);
      }
      navigate(window.location.pathname || "/", { replace: true });
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-cream">
      <LogoMark className="h-12 w-12 animate-pulse" />
    </div>
  );
}
